/**
 * Active (billable) sale-line filters for invoice + table save payloads.
 *
 * Why: Backend invoice flow only keeps currentsale rows with archived=0 OR NULL.
 * After cashiers void every line on a table, voided rows stay in DB as archived=1.
 * If the FE still posts those rows (or an empty active set), BE returns
 * "no invoice lines specied" and the cashier cannot finish clearing the sale.
 *
 * New cart lines rarely set archived/processed — missing flags must NOT mean voided.
 * docs: docs/FRONTEND.md (invoice payload / void); BE currentsale archived filter
 */

/**
 * @param {*} line Cart / table line object
 * @returns {boolean} true when the line should be sent on invoice/save
 */
export function isActiveSaleLine(line) {
    if (!line) return false;

    // Qty <= 0 is the FE voided/zeroed marker (voidItem removes at 0; defense if it remains).
    const qty = Number(line.Qty);
    if (!Number.isFinite(qty) || qty <= 0) return false;

    // BE archives voided currentsale rows — never re-invoice them.
    const archived = line.archived ?? line.Archived;
    if (archived === 1 || archived === true || archived === '1') return false;

    // Explicit processed=0 only. undefined/null = normal FE line, keep it.
    if (line.processed === 0 || line.Processed === 0) return false;

    return true;
}

/**
 * @param {Array|*} lines Sale lines from cart or table payload
 * @returns {Array} Active lines only (never mutates input)
 */
export function filterActiveSaleLines(lines) {
    if (!Array.isArray(lines)) return [];
    return lines.filter(isActiveSaleLine);
}
